<!-- Vertical Menu -->
<ng-container *ngIf="layout === 'vertical'">
  <ng-container *ngFor="let item of menu">
    <!-- section -->
   
    <li core-menu-vertical-section *ngIf="item.type == 'section' && isRoleAllowed(item?.role)" [item]="item" class="navigation-header"></li>
    <!-- sub-menu item/collapsible of sections  -->
    <ng-container *ngIf="item.type == 'section'  && isRoleAllowed(item?.role)">
      <ng-container *ngFor="let itemChildren of item.children">
        <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
        <!-- *ngIf="item.type == 'item' && item?.role[0] == currentUser?.roles[0]" -->
        <li
          core-menu-vertical-item
          
          *ngIf="itemChildren.type == 'item' && !isRoleAllowed(itemChildren?.role)"
          [item]="itemChildren"
          [currentUser]="currentUser"
          [ngClass]="{ disabled: itemChildren.disabled === true }"
          [routerLinkActive]="!itemChildren.openInNewTab ? 'active' : ''"
          [routerLinkActiveOptions]="{ exact: itemChildren.exactMatch || false }"
        >
        
          <span [routerLink]="itemChildren.openInNewTab ? [] : [itemChildren.url]" class="d-none"></span>
        </li>
        <!-- collapsible -->
        <li
          core-menu-vertical-collapsible
          *ngIf="itemChildren.type == 'collapsible' && isRoleAllowed(itemChildren?.role)"
          [item]="itemChildren"
          class="nav-item has-sub"
        ></li>
      </ng-container>
    </ng-container>

    <!-- item -->
    <li
      core-menu-vertical-item
      *ngIf="item.type == 'item' && isRoleAllowed(item?.role)"
      [item]="item"
      [currentUser]="currentUser"
      [ngClass]="{ disabled: item.disabled === true }"
      [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
      [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
    >
      <span [routerLink]="item.openInNewTab ? [] : [item.url]" class="d-none"></span>
      <span></span>
    </li>
    <!-- collapsible -->
    <li core-menu-vertical-collapsible *ngIf="item.type == 'collapsible'" [item]="item" class="nav-item has-sub"></li>
  </ng-container>
</ng-container>
<!--/ Vertical Menu -->

<!-- Horizontal Menu -->
<ng-container *ngIf="layout === 'horizontal'">
  <ng-container *ngFor="let item of menu">
    <!-- section -->
    <li core-menu-horizontal-collapsible *ngIf="item.type == 'section' && isRoleAllowed(item?.role)" [item]="item" class="dropdown nav-item"></li>

    <!-- item | if openInNewTab set routerLink & routerLinkActive blank -->
    <li
      core-menu-horizontal-item
      *ngIf="item.type == 'item' && isRoleAllowed(item?.role)"
      [item]="item"
      [ngClass]="{ disabled: item.disabled === true }"
      [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
      [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
    >
      <span [routerLink]="item.openInNewTab ? [] : [item.url]" class="d-none"></span>
    </li>

    <!-- collapsible -->
    <li
      core-menu-horizontal-collapsible
      *ngIf="item.type == 'collapsible' && isRoleAllowed(item?.role)"
      [item]="item"
      class="dropdown dropdown-submenu"
    ></li>
  </ng-container>
</ng-container>
<!--/ Horizontal Menu -->
